import React from "react";
import { ACCESS_LEVEL_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const ProjectAccessLevelAutoSuggest = (props) => {
    const suggestRole = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        } else {
            q = "";
        }

        return Promise.resolve(
            Object
                .keys(ACCESS_LEVEL_DICTIONARY)
                .filter(accessKey => (ACCESS_LEVEL_DICTIONARY[accessKey] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        );
    }

    return (
        <AutoSuggest
            label="Access level"
            fetchOptions={suggestRole}
            renderOption={(accessLevel) => ({
                value: accessLevel,
                label: ACCESS_LEVEL_DICTIONARY[accessLevel]
            })}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default ProjectAccessLevelAutoSuggest;
